import React from 'react';

const MessageLinkeable = ({ style, onClick, message }) => (
    <div style={style} className="message-linkeable" onClick={onClick}>
        {message}
    </div>
);

export default MessageLinkeable;
